import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useCommunityReview } from "../../hooks/community/useAdminReview";
import { LoaderOverlay } from "../../hooks/loader/LoaderOverlay";
import { CommunityInputComment } from "../community/components/CommunityInputComment";
import { CommunityDiscussComments } from "../community/models/CommunityDiscussComments";
import { CommunityAdminBanModal } from "./components/CommunityAdminBanModal";
import { CommunityAdminCommentsWrap } from "./components/CommunityAdminCommentsWrap";
import { CommunityAdminMedia } from "./components/CommunityAdminMedia";
import { CommunityAdminReviewContent } from "./components/CommunityAdminReviewContent";
import { useResourceUpload } from "../../hooks/community/useResourceUpload";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "../../../setup";
import { UserModel } from "../../modules/auth/models/UserModel";
import { UserRole } from "../../constants/roles";
import { hasRole } from "../../utils/permissions";
import { showErrorAlert } from "../../helpers/alert";

export const CommunityAdminReviewPage = () => {
    const user = useSelector<RootState>(({auth}) => auth.user, shallowEqual) as UserModel
    const history = useHistory();

    useEffect(() => {
        allowed();
    }, []);

    const allowed = () => {
        const _isAdmin = hasRole(user, UserRole.ADMIN)
        if(!_isAdmin) {
            history.goBack();
            showErrorAlert({ title: 'Access Denied', message: 'You do not have permission to access this page.' });
        }
    }

    const { id } = useParams() as any;
    const [ban, setBan] = useState<{ id: number, target:  'user' | 'forum', username?: string } | null>(null);
    const { details, error, loading: loadDetails, addComment, deleteComment, toBanUser, toBanForum, deleteResource } = useCommunityReview(id);
    const { files, insertFile, removeFile, processFiles } = useResourceUpload(id);
    const [replySelect, setReplySelect] = useState<CommunityDiscussComments | null>(null);

    useEffect(() => {
        if(!!error)
            return history.replace('/admin/community');
    }, [error]);

    useEffect(() => {
        document.body.classList.add('admin-community-review-container')
        return () => document.body.classList.remove('admin-community-review-container')
    }, []);

    return (
        <>
        <LoaderOverlay visible={loadDetails} message={'Loading...'} />
        {!!details && !!ban && (
            <CommunityAdminBanModal
                id={ban.id} 
                target={ban.target} 
                username={ban.username}
                onClose={() => setBan(null)} 
                onBan={async (target, id, type, reason, duration) => {
                    if(target === 'user')
                        await toBanUser(id, type, duration, reason)
                    else
                        await toBanForum(id, type, duration, reason);
                    setBan(null);
                }} 
            />
        )}
        { !!details && (
            <>
                <div className="admin-community-review__wrapper">
                    <div className="admin-community-review__comments">
                        <div className="w-100 tap-flex-center justify-content-start">
                            <div className="nb-link-underline-500 w-auto cursor-pointer" onClick={()=> history.replace('/admin/community')}>
                                Back
                            </div>
                        </div>
                        
                        <h3>{details.type}</h3>

                        <CommunityAdminCommentsWrap 
                            comments={details.comments}
                            onSuspendUser={(c) => setBan({ target: 'user', id: c.authorId, username: c.author })}
                            onDeleteComment={(c) => deleteComment(c.id)}
                        />

                        <CommunityInputComment 
                            cleanReply={() => setReplySelect(null)}
                            onSendComment={(value) => addComment(value, replySelect?.id, processFiles)}
                            onAddFile={insertFile}
                            files={files}
                            OnRemoveFile={(f) => removeFile(f.file)}
                        />
                    </div>
                    <div className="admin-community-review__content">
                        <CommunityAdminReviewContent
                            type={details.type}
                            author={details.author}
                            circles={details.circles}
                            content={details.content}
                            topic={details.topic}
                            facilitator={details.facilitator}
                            onSuspendForum={() => setBan({ id, target: "forum", username: details.author.username })}
                        />
                        <CommunityAdminMedia mediafiles={details.mediafiles} onDelete={m => deleteResource(m.id)}/>
                    </div>
                </div>
            </>
        )}
        </>
    )
}